module.exports = __webpack_public_path__ + "static/media/bi_analysis.7332c4d4.svg";